import {
    MIGRATION_PROGRESS,
    MIGRATION_SUCCESS,
    MIGRATION_HISTORY,
    MIGRATION_CLEAR, MIGRATION_FAILED,
    AWS_MIGRATION_HISTORY,
    AWS_MIGRATION_PENDING,
    WASABI_MIGRATION_HISTORY,
    WASABI_MIGRATION_PENDING
} from "../actions/migrations"

export default (state={}, action={})=> {
    switch (action.type) {
        case MIGRATION_FAILED:
            if(!(action||{}).data)
                return state

            return {
                ...state,
                ...{_:Math.random()},
                ongoing:{...(state.ongoing||{}), ...(action||{}).data}
            }
        case MIGRATION_SUCCESS:
        case MIGRATION_PROGRESS:
            if(!(action||{}).data)
                return state

            return {
                ...state,
                ...{_:Math.random()},
                ongoing:{...(state.ongoing||{}), ...(action||{}).data}
            }
        case MIGRATION_CLEAR:
            let ongoing  = state.ongoing||{}
            if ((action||{}).data.id)
                delete ongoing[(action||{}).data.id]
            else {
                for (let key in state.ongoing) {
                    if (state.ongoing[key].status === 'Succeeded' || state.ongoing[key].percent === 100)
                        delete state.ongoing[key]
                }
            }

            return {
                ...state,
                ...{_:Math.random(), updated:new Date()},
                ongoing:state.ongoing
            }
        case MIGRATION_HISTORY:
            return {
                ...state,
                history:(action||{}).data.history||{}
            }
        case AWS_MIGRATION_PENDING:
            return {
                ...state,
                awsLoading:true
            }
        case AWS_MIGRATION_HISTORY:
            return {
                ...state,
                awshistory:(action||{}).data.awshistory||{},
                awsLoading:false
            }
        case WASABI_MIGRATION_PENDING:
            return {
                ...state,
                wasabiLoading:true
            }
        case WASABI_MIGRATION_HISTORY:
            return {
                ...state,
                wasabihistory:(action||{}).data.wasabihistory||{},
                wasabiLoading:false
            }


        default:
            return state
    }
}
